var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007fb5;}.cls-2{fill:#fff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "14-linkedin",
    id: "_14-linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 64,
    rx: 11.2,
    ry: 11.2,
    width: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 32.72,
    width: 9.03,
    x: 8.99,
    y: 23.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.2,23.54C41.54,21,36.72,25.3,34.66,27.7V23.54h-9V56.26h9V39a8.45,8.45,0,0,1,2.23-5.92,4.75,4.75,0,0,1,3.41-1.67A5.42,5.42,0,0,1,44.24,33a6.13,6.13,0,0,1,1.7,4.35V56.26H56.1V36S57.23,26.92,48.2,23.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.5,
    cy: 13.38,
    r: 5.64
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.9c537f31af3925b5887b468a4cb7836f.svg";
export { ForwardRef as ReactComponent };